const API_URL = process.env.REACT_APP_API_URL;

export async function criarAvaliacao(data) {
  try {
    const response = await fetch(`${API_URL}/avaliacoes`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) throw new Error('Erro ao criar avaliação');

    const result = await response.json();
    return result;
  } catch (error) {
    console.error('[Erro criarAvaliacao]', error);
    return null;
  }
}

export async function buscarAvaliacaoPorId(id) {
  try {
    const response = await fetch(`${API_URL}/avaliacoes/${id}`);

    if (!response.ok) throw new Error('Erro ao buscar avaliação');

    const result = await response.json();
    return result;
  } catch (error) {
    console.error('[Erro buscarAvaliacaoPorId]', error);
    return null;
  }
}
